var type = "switchSlow";

// After a switcharoonie the worm is heavily slowed, then its speed steps back up to
// normal over RAMP_DURATION seconds along an exponential curve (slow crawl at first,
// accelerating toward full speed). The ramp is QUANTIZED into discrete steps on
// purpose: path segments only merge while speed is unchanged (see
// addWormPathSegment), so a continuously-changing speed would spawn an un-mergeable
// micro-segment every frame and shred the trail into fragments. Holding each speed
// level for a stretch keeps the trail clean.
var START_SPEED_FACTOR = 0.1; // heavily slowed at the moment of the switch
var RAMP_DURATION = 3;        // seconds until full speed is restored
var STEPS = 9;                // number of discrete speed levels across the ramp

function activate({ duration = RAMP_DURATION, wormId } = {}) {
    return {
        duration: duration,
        timeLeft: duration,
        wormId: wormId,
        type: type
    };
}

function changeSpeed(gameState, effect, wormSpeed) {
    var timeActive = effect.duration - effect.timeLeft;
    var progress = Math.max(0, Math.min(1, timeActive / RAMP_DURATION)); // 0..1
    var step = Math.min(STEPS - 1, Math.floor(progress * STEPS));        // 0..STEPS-1
    var stepFraction = step / (STEPS - 1);                               // 0..1
    // Exponential ramp: 0.1 at the start, accelerating up to 1.0 at the end.
    var factor = Math.pow(START_SPEED_FACTOR, 1 - stepFraction);
    return wormSpeed * factor;
}

export {
    type,
    activate,
    changeSpeed
};
